module.exports = __webpack_public_path__ + "img/home_bottom.d97606d0.png";